// extracted by mini-css-extract-plugin
export var closeButton = "_j3-2";
export var closeButtonIcon = "_j3-3";
export var lightboxContent = "_j3-1";
export var lightboxOverlay = "_j3-0";